import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import * as Rx from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class Network {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  get isOnline$(): Rx.Observable<boolean> {
    if (isPlatformServer(this.platformId)) {
      return Rx.of(true);
    }

    return Rx.merge(
      Rx.fromEvent(window, 'online'),
      Rx.fromEvent(window, 'offline'),
    ).pipe(
      map(({ type }) => type === 'online'),
      startWith(navigator.onLine),
    );
  }
}
